module.exports = __webpack_public_path__ + "static/media/details-10-image-6.9bc89e75.jpg";